import { Alert, Button, Container, Icon, Stack } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AccountService, UserDto } from "../../api/identity";
import { HelpIconButton, PageHeader, Spinner } from "../../components/exports";
import { UserContext } from "../../contexts/UserContext";
import User from "./User";

// updated
export default function ListUsers() {
    const navigate = useNavigate();

    const [users, setUsers] = useState<UserDto[] | null>(null);

    const user = useContext(UserContext);

    const isOwner = user.role === 1;

    useEffect(() => {
        AccountService.listUsers().then((r) => {
            setUsers(r);
        });
    }, []);

    const goToCreateUser = () => {
        navigate(`/user/create`);
    };

    if (!users) {
        return <Spinner />;
    }

    return (
        <Container maxWidth="sm">
            <PageHeader
                title="لیست اپراتور ها"
                action={
                    <Stack direction="row" spacing={1} alignItems="center">
                        <HelpIconButton tag="manage_users" />
                        <Button
                            onClick={goToCreateUser}
                            variant="contained"
                            disabled={!isOwner}
                            startIcon={<Icon>add</Icon>}
                        >
                            افزودن کاربر
                        </Button>
                    </Stack>
                }
            />

            {!isOwner && (
                <Alert severity="error">
                    تنها صاحب حساب کاربری به بخش مدیریت کاربران دسترسی دارد
                </Alert>
            )}

            {isOwner && (
                <Stack alignItems="center" spacing={2}>
                    {users.map((u) => (
                        <User key={u.id} user={u} />
                    ))}
                </Stack>
            )}
        </Container>
    );
}
